import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Botón premium en forma de píldora. Variantes:
 *  - solid  : fondo dorado rosado (acción principal)
 *  - outline: contorno ciruela
 *  - light  : para fondos oscuros (ciruela)
 */
const base =
  "group inline-flex items-center justify-center gap-3 rounded-full px-8 py-4 text-sm uppercase tracking-[0.18em] font-medium transition-[background-color,color,border-color,transform] duration-500 ease-out hover:-translate-y-0.5 cursor-pointer";

const variants = {
  solid: "bg-rosegold text-ivory hover:bg-plum",
  outline: "border border-plum/40 text-plum hover:border-plum hover:bg-plum hover:text-ivory",
  light: "bg-ivory text-plum hover:bg-rosegold hover:text-ivory",
};

export const Button = ({
  children,
  variant = "solid",
  to,
  href,
  onClick,
  type = "button",
  withArrow = true,
  className = "",
  testId,
}) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      {withArrow && (
        <ArrowUpRight
          className="h-4 w-4 transition-transform duration-500 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          strokeWidth={1.5}
        />
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testId}>
        {inner}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId}>
        {inner}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} className={cls} data-testid={testId}>
      {inner}
    </button>
  );
};

export default Button;
